import * as React from 'react'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import classNames from 'classnames'
import { UpdateActionButton } from '../LessonListActionButton'
import { getLocationName } from '../../types/location'
import { isOnline, shouldShowSecondLesson } from '../../types/trialLessons'
import { LocationBadge3 } from '../LocationLabel3'
import { TrialLessonIndexView } from '../../types/trialLessons'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

export const SelectedLessonSummary2 = ({
  lesson,
  onUnselect,
}: {
  lesson: TrialLessonIndexView
  onUnselect: () => void
}) => {
  const selectedLesson = lesson //.get();
  const hasSecondTrial = shouldShowSecondLesson(selectedLesson)
  const featured = isOnline(selectedLesson) && hasSecondTrial

  return (
    <>
      {selectedLesson && (
        <div
          id="selected-lesson-summary"
          className="cursor-pointer bg-white border border-[#e0e0e0] relative flex justify-between items-center p-2 px-4 flex-grow-0 flex-shrink-0 md:w-[327px] lg:w-[327px]"
          onClick={() => onUnselect()}
        >
          <div
            className="flex items-center justify-start md:h-[51px] lg:h-[51px]"
            id={`card-list-item-${selectedLesson.id}`}
          >
            {getLocationName(selectedLesson.location) !== 'オンライン' && (
              <LocationBadge3 location={selectedLesson.location} />
            )}
            <div className={classNames('ml-2', { 'md:mt-[3px]': featured })}>
              <span className="font-europa text-[14px] font-bold">
                {dayjs(selectedLesson.starts_at)
                  .tz('Asia/Tokyo')
                  .format('HH:mm')}
                -{' '}
                {dayjs(selectedLesson.ends_at).tz('Asia/Tokyo').format('HH:mm')}
              </span>
            </div>
          </div>
          <UpdateActionButton onClick={onUnselect} />
        </div>
      )}
    </>
  )
}
